import { useCallback } from 'react'

import { Segment } from 'core/analytics/segment'

import { TRACKING_EVENT_NAMES } from './constants'
import { useTrack } from './useTrack'

export const useTrackTrialExtended = () => {
  const track = useTrack()

  return useCallback((properties = {}) => {
    const daysToAdd = properties.days_to_add
    const newTrialDateEnd = properties.new_trial_date_end
    const trialId = properties.trial_id

    if (!daysToAdd || !newTrialDateEnd || !trialId) {
      console.warn('Trial Extended event missing required properties:', {
        days_to_add: daysToAdd,
        new_trial_date_end: newTrialDateEnd,
        trial_id: trialId
      })
      return
    }

    const eventProperties = {
      days_to_add: daysToAdd,
      new_trial_date_end: newTrialDateEnd,
      trial_id: trialId
    }

    // Segment v2 (server-mode) for Segment
    track({
      name: TRACKING_EVENT_NAMES.TRIAL_EXTENDED,
      properties: eventProperties
    })

    // Segment v1 (device-mode) for Braze
    Segment.track(TRACKING_EVENT_NAMES.TRIAL_EXTENDED, eventProperties)
  }, [track])
}
